var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app-admin-wrap-layout-6",style:({
    background: _vm.$vuetify.theme.themes[_vm.theme].background,
    color: _vm.$vuetify.theme.themes[_vm.theme].color,
  })},[_c('Header'),_c('side-bar'),_c('base-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }